import {cn} from '~/design-system/utils'
import {type HgTableTagsCell, HgTagGroup} from '~/design-system/hg/components'

const TagCell = ({tags, className}: HgTableTagsCell) => {
  return (
    <div className={cn('flex h-full w-full', className)}>
      <div className="flex w-fit items-center">
        <HgTagGroup canWrap={false} tags={tags} />
      </div>
    </div>
  )
}

export default TagCell
